import { Box, Button, Grid2, ImageList, Typography } from '@mui/material'
import React from 'react'
import { ScrollContainerWithHeader } from '../../shared/components/student/ScrollComponent'
import RelatedClassCard from '../../shared/components/student/RelatedClassCard'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { Constants, Grid_Gap } from '../../shared/constants'
import SearchInput from '../../shared/components/student/SearchInput'
import CustomDivider from '../../shared/utils/CustomDivider'
import { relatedCourseData } from '../../data/relatedcourse'
import { SearchSection } from './MyCourses'
import { FilterButton } from '../../shared/utils/IconButton'
import HighLightCard from '../../shared/components/student/HighLightCard'
import { ImageCard } from './Memories'
import { useMemoryByApart } from '../../assets/api/UseStudentGetApi'
import useAuthStore from '../../store/useAuthStore'
import { SkeletonCom } from '../../shared/utils/SkeletonCom'
export const imageList = [
  { src: Constants.customImages.MemoryImg1, height: 400 },
  { src: Constants.customImages.MemoryImg2, height: 195 },
  { src: Constants.customImages.MemoryImg3, height: 195 },
  { src: Constants.customImages.MemoryImg4, height: 400 },
  { src: Constants.customImages.MemoryImg3, height: 195 },
  { src: Constants.customImages.MemoryImg3, height: 195 },
  { src: Constants.customImages.MemoryImg3, height: 195 },
  { src: Constants.customImages.MemoryImg3, height: 195 },
  { src: Constants.customImages.MemoryImg3, height: 195 },
  { src: Constants.customImages.MemoryImg3, height: 195 },
];

const Moments = () => {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useMemoryByApart({perPage:10});

  const allMemories = data?.pages.flatMap((page) => page.data) || [];



  return (
    <Box>

      {/* <SearchSection /> */}
      {/* <CustomDivider orientation='horizontal' />
      <ScrollContainerWithHeader headerText={"Related Courses"}>
        {relatedCourseData.map((item, index) => (
          <Grid2 key={index} size={{xs:12,sm:8,md:6}} sx={{ flex: '0 0 auto' }}>
            <RelatedClassCard img={item.img} name={item.name} />
          </Grid2>
        ))}
      </ScrollContainerWithHeader> */}

      <CustomDivider orientation='horizontal' />

      <NormalContainerWithHeader
        headerText={"Highlights"}
        RightContent={
          hasNextPage && (
            <Button
              variant="outlined"
              onClick={() => fetchNextPage()}
              disabled={isFetchingNextPage}
            >
              {isFetchingNextPage ? 'Loading...' : 'View More'}
            </Button>
          )
        }
      >

        <Grid2 container spacing={Grid_Gap}>


          {!isLoading &&
            allMemories?.length === 0 ?
            <Box sx={{display:"flex",justifyContent:"center",alignItems:"center"}}>
              <Typography textAlign={"center"}>No HighLight</Typography>
            </Box> :
            allMemories?.map((item, index) => (
              <Grid2 key={index} size={{ xs: 12, sm: 4, md: 6 }} sx={{ flex: '0 0 auto' }}>
                <HighLightCard images={[item?.memories_images]} img={item?.memories_images} title="Remember the Day?" />
              </Grid2>
            ))
          }

          {
            isLoading &&
            [...Array(2)].map((_, index) => (
              <Grid2 key={index} size={{ xs: 8, sm: 4, md: 6 }} sx={{ flex: '0 0 auto' }}>
                <SkeletonCom key={index} />
              </Grid2>
            ))

          }
        </Grid2>
      </NormalContainerWithHeader>
      <CustomDivider orientation='horizontal' />

      {/* <NormalContainerWithHeader headerText={"Photo Gallery"} RightContent={

        <Grid2
          container
          spacing={"20px"}
          width={"60%"}
          justifyContent="flex-end"

        >
          <SearchInput />
          <FilterButton src={Constants.customImages.FilterDark} bgcolor={"transparent"} border={"0.5px solid #A9B7FD"} />

        </Grid2>
      }>
        <Grid2 container spacing={Grid_Gap} >
          <ImageCard src={imageList[0].src} height={imageList[0].height} />
          <Grid2 container size={{ lg: 4, xs: 12 }} direction="column" spacing={1} justifyContent={"space-between"}>
            <ImageCard src={imageList[1].src} height={imageList[1].height} isNested={true} />
            <ImageCard src={imageList[2].src} height={imageList[2].height} isNested={true} />
          </Grid2>
          <ImageCard src={imageList[3].src} height={imageList[3].height} />
          {
            imageList.slice(4).map((item, index) => (
              <ImageCard src={item.src} height={item.height} key={index} />
            ))
          }
        </Grid2>
      </NormalContainerWithHeader> */}
    </Box>
  )
}

export default Moments